import {
    Document,
    Font,
    Page,
    StyleSheet,
    Text,
    View
} from "@react-pdf/renderer";

Font.register({
    family: "Tajawal",
    src: "https://fonts.gstatic.com/s/tajawal/v10/Iura6YBj_oCad4k1rzaLCr5IlLA.ttf",
});



const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontFamily: "Tajawal",
        backgroundColor: '#FFFFFF',
        direction: 'rtl',
    },
    header: {
        marginBottom: 20,
        textAlign: 'center',
        borderBottom: 1,
        borderBottomColor: '#EEE',
        paddingBottom: 10,
    },
    title: {
        fontSize: 18,
        color: '#4c1d95',
    },
    table: {
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: '#bfbfbf',
        flexDirection: 'column'
    },
    tableRow: {
        flexDirection: "row-reverse",
        borderBottomWidth: 1,
        borderBottomColor: '#EEE',
        alignItems: 'center',
        minHeight: 30,
    },
    tableHeader: {
        backgroundColor: '#f8fafc',
    },
    tableCol: {
        width: "16.6%",
        padding: 5,
    },
    tableCellHeader: {
        fontSize: 10,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    tableCell: {
        fontSize: 9,
        textAlign: 'center',
    },
    footer: {
        marginTop: 20,
        padding: 10,
        backgroundColor: '#f1f5f9',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    }
});

const InoviceDetailsReport = ({ invoice, total, t }: any) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <Text style={styles.title}>{t("Invoice")}</Text>
                </View>

                <View style={styles.table}>
                    <View style={[styles.tableRow, styles.tableHeader]}>
                        <View style={styles.tableCol}><Text style={styles.tableCellHeader}>{t("item_id")}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.tableCellHeader}>{t("item_name")}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.tableCellHeader}>{t("barcode")}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.tableCellHeader}>{t("item_quantity")}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.tableCellHeader}>{t("item_price")}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.tableCellHeader}>{t("total")}</Text></View>
                    </View>

                    {invoice?.map((item: any, index: number) => (
                        <View style={styles.tableRow} key={index}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item?.item_id}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item?.item_name || "---"}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item?.barcode || "---"}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item?.item_quantity}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item?.item_price || "---"}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}> {Number(item?.item_price) * Number(item?.item_quantity) || "-"}</Text>
                            </View>
                        </View>
                    ))}
                </View>

                <View style={styles.footer}>
                    <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{t("Total Amount")}</Text>
                    <Text style={{ fontSize: 12, color: '#7c3aed' }}>{total}</Text>
                </View>
            </Page>
        </Document>
    );
};

export default InoviceDetailsReport;